/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_SubmitInputs */

const vi_pl_pnk_submit = /** @type {(inputs: Pl_Pnk_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu`)
};

/**

* @param {Pl_Pnk_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_submit = /** @type {((inputs?: Pl_Pnk_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_submit(inputs)
});